export default __webpack_public_path__ + "3aed68925493fa366d00ca229bc780d7.png";